import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Questionnaire from '../entities/questionnaire'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';

interface QuestionnaireState extends ListState<Questionnaire> {
    editQuestionnaire: Questionnaire;
}
class QuestionnaireModule extends ListModule<QuestionnaireState, any, Questionnaire>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Questionnaire>(),
        loading: false,
        editQuestionnaire: new Questionnaire(),
    }
    actions = {
        async getAll(context: ActionContext<QuestionnaireState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Questionnaire/GetAllOfBack', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Questionnaire>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<QuestionnaireState, any>, payload: any) {
            await Ajax.post('/api/services/app/Questionnaire/Create', payload.data);
        },
        async update(context: ActionContext<QuestionnaireState, any>, payload: any) {
            await Ajax.put('/api/services/app/Questionnaire/Update', payload.data);
        },
        async delete(context: ActionContext<QuestionnaireState, any>, payload: any) {
            await Ajax.delete('/api/services/app/Questionnaire/Delete?Id=' + payload.data.id);
        },
        async auditedQuestionnaire(context: ActionContext<QuestionnaireState, any>, payload: any) {
            await Ajax.post('/api/services/app/Questionnaire/auditedQuestionnaire' , payload.data);
        },
        async get(context: ActionContext<QuestionnaireState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Questionnaire/Get?Id=' + payload.data.id);
            context.state.editQuestionnaire = reponse.data.result as Questionnaire;
        }
    };
    mutations = {
        setCurrentPage(state: QuestionnaireState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: QuestionnaireState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: QuestionnaireState, questionnaire: Questionnaire) {
            state.editQuestionnaire = questionnaire;
        }
    }
}
const questionnaireModule = new QuestionnaireModule();
export default questionnaireModule;